import React from 'react';

type TableHeaderProps = {
  title: string;
  icon?: JSX.Element;
  className?: string;
  descriptionClassName?: string;
  id?: string;
  description?: string;
};

const TableHeader = (props: TableHeaderProps) => (
  <div>
    <div
      className={props.className}
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <p id={`table-header-${props.id}`}>{props.title}</p>
    </div>
    {props.description ? (
      <div
        className={props.descriptionClassName}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <p>{props.description}</p>
      </div>
    ) : (
      <></>
    )}
  </div>
);

export default TableHeader;
